import React from "react"

export const HeaderComponent = () => {
  return (
    <>
      <tmo-digital-header></tmo-digital-header>
    </>
  )
}
